export const AUTH_INDEX_PATH = "/auth";
export const AUTH_SIGNUP_PATH = `${AUTH_INDEX_PATH}/signup`;
export const AUTH_SETUP_PATH = `${AUTH_INDEX_PATH}/setup`;
export const AUTH_FORGOT_PASS_PAGE = `${AUTH_INDEX_PATH}/reset-password`;

export const REPORT_INDEX_PATH = "/report";
export const WORKSPACE_PATH = "/workspace";
export const STAFF_PATH = "/staff";
export const TASK_PATH = "/task";
export const PROJECT_PATH = "/project";

// サポート・利用規約など、その他
export const SUPPORT_LINK_PATH = "https://suitup.jp/contact-form/";
export const SUITUP_DESCRIPTION_DOC_PATH =
  "https://drive.google.com/file/d/1n4xSBIaUIYlwl9W7cwk_9CJ3timIKpuA/view?usp=sharing";
export const TERMS_PATH = "https://drive.google.com/file/d/1mc5yX8hb7GwSOBZTB9Zgq04flSiL2UbR/view?usp=sharing";
export const SALES_TERMS_PATH = "https://drive.google.com/file/d/1zpwCudylKnyW-JxCVfipyVgkqBLoHIpD/view?usp=sharing";
export const PRIVACY_POLICY_PATH = "https://suits.co.jp/privacy-policy/";
export const SUITUP_COMPANY_PATH = "https://suits.co.jp/";

// IMAGE系
const BACKGROUND_IMAGE_PATH = "/background";
export const HEADER_IN_BOARD_BG_PATH = BACKGROUND_IMAGE_PATH + "/brand-header-in-board.svg";
export const AUTH_LEFT_BG_PATH = BACKGROUND_IMAGE_PATH + "/auth-left-bg.png";
const ASSETS_PATH = "/assets";
export const NO_IMAGE_PATH = ASSETS_PATH + "/no_img.png";

export const MYPAGE_INDEX_PATH = `/mypage`;
export const MYPAGE_PROFILE_PATH = `${MYPAGE_INDEX_PATH}/profile`;
export const MYPAGE_EMAIL_INFO_PATH = `${MYPAGE_INDEX_PATH}/email-address`;
export const MYPAGE_PASSWORD_PATH = `${MYPAGE_INDEX_PATH}/password`;
export const MYPAGE_COMPANY_INFO_PATH = `${MYPAGE_INDEX_PATH}/company-info`;

export const TASK_INDEX_PATH = "/task";
export const ALL_TASK_PATH = `${TASK_INDEX_PATH}/all`; // パス情報に、typeを含む
export const MY_TASK_PATH = `${TASK_INDEX_PATH}/me`; // パス情報に、typeを含む
export const GROUP_TASK_PATH = `${TASK_INDEX_PATH}/group`; // パス情報に、idとtypeを含む
export const MGMT_TASK_PATH = `${TASK_INDEX_PATH}/management`; // パス情報に、typeを含む
export const PUBLIC_TASK_PATH = `${TASK_INDEX_PATH}/public`; // パス情報に、typeを含む
export const PROJECT_TASK_PATH = `${TASK_INDEX_PATH}/project`; // パス情報に、idとtypeを含む
